import { Typography } from '@mui/material';
import ManageChoicesTable from './ManageChoicesTable';
const ManageChoices = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage Choice
      </Typography>
      <ManageChoicesTable />
    </>
  );
};

export default ManageChoices;
